<template>
  <el-dialog
    append-to-body
    width="500px"
    title="认证审核"
    center
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      v-loading="loading"
      element-loading-text="加载中…"
      ref="elFormDom"
      label-width="110px"
      label-position="right"
      :model="form.data"
      :rules="form.rules"
    >
      <el-form-item prop="name" label="姓名：">
        {{ info.nickname }}
      </el-form-item>
      <el-form-item prop="name" label="身份证号：">
        {{ info.id_card }}
      </el-form-item>
      <el-form-item prop="name" label="注册号码：">
        {{ info.account }}
      </el-form-item>
      <el-form-item prop="name" label="学历：">
        {{ info.education_str }}
      </el-form-item>
      <el-form-item prop="name" label="毕业院校：">
        <div style="display: flex;align-items: center;">
          <div>{{ info.school_str }}</div>
          <el-tag style="margin-left:6px" v-if="info&&info.college_type_str&&info.college_type_str.includes('985')" size="mini" type="success">985</el-tag>
          <el-tag style="margin-left:6px" v-if="info&&info.college_type_str&&info.college_type_str.includes('211')" size="mini" type="warning">211</el-tag>
        </div>
      </el-form-item>
      <el-form-item prop="name" label="专业：">
        {{ info.major_str }}
      </el-form-item>
      <el-form-item prop="name" label="学历证明：">
        <el-image
          v-for="(item, index) in info.certs ? info.certs.split(',') : []"
          :key="index"
          :src="item"
          style="width: 60px; height: 60px; margin-right: 10px"
          :preview-src-list="[item]"
        ></el-image>
      </el-form-item>
      <el-form-item prop="name" label="提交时间：">
        {{ info.create_time }}
      </el-form-item>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="center">
        <el-button
          type="primary"
          :loading="form.loading"
          :disabled="form.loading"
          @click="confirm"
          >审核通过</el-button
        >
        <el-button
          @click="toReject"
          type="danger"
          :loading="form.loading"
          :disabled="form.loading"
          >审核拒绝</el-button
        >
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      info: {},
      visible: false,
      loading: false,
      form: {
        loading: false,
        data: {
          date: "",
        },
        rules: {
          date: [{ required: true, message: "必填项", trigger: "change" }],
        },
      },
    };
  },
  created() {},
  methods: {
    reset(done) {
      this.info = {};
      this.$refs.elFormDom.resetFields();
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    getDetail(row) {
      this.info = row;
    },
    // 提交
    confirm() {
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          this.form.loading = true;
          let params = {
            id: this.info.id,
            is_pass: 1,
          };
          this.$http
            .post("/admin/userAuth/check", params)
            .then((res) => {
              if (res.code === 1) {
                this.toggle(false);
                this.$message.success("操作成功");
                this.$emit("refresh");
              }
            })
            .finally(() => {
              this.form.loading = false;
            });
        }
      });
    },
    toReject() {
      this.$prompt("请输入拒绝理由（100字之内）", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /\S+/,
        inputErrorMessage: "请输入驳回原因",
        inputPlaceholder: "请输入驳回原因",
      }).then(({ value }) => {
        let params = {
          id: this.info.id,
          is_pass: 2,
          refuse_reason: value,
        };
        this.$http
          .post("/admin/userAuth/check", params)
          .then((res) => {
            if (res.code === 1) {
              this.$message.success("操作成功");
              this.toggle(false);
              this.$emit("refresh");
            }
          })
          .finally(() => {
            this.form.loading = false;
          });
      });
    },
  },
};
</script>
